import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import CustomWidgetRenderer from "@webcore/components/domain/dashboard/renderers/custom/CustomWidgetRenderer.tsx";
import { useDataChangeVersion } from "@webcore/hooks/useDataChangeVersion";

/**
 * Ops route for a custom widget. Reads the widget identifiers from the path and the filters from
 * the query string, and renders the shared CustomWidgetRenderer against the read-only session
 * established by MfeBootstrap.
 */
function OpsCustomWidgetRoute() {
  const widgetDataVersion = useDataChangeVersion("WidgetData");

  const { dashboardId, viewId, widgetId, dataPipelineConfigurationId } = useParams<{
    dashboardId: string;
    viewId: string;
    widgetId: string;
    dataPipelineConfigurationId: string;
  }>();

  const [searchParams] = useSearchParams();
  const filters = useMemo(() => {
    const result: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }, [searchParams]);

  if (dashboardId === undefined || viewId === undefined || widgetId === undefined || dataPipelineConfigurationId === undefined) {
    return <div className="widget-error">Missing widget parameters.</div>;
  }

  return (
    <CustomWidgetRenderer
      key={widgetDataVersion}
      dashboardId={dashboardId}
      viewId={viewId}
      widgetId={widgetId}
      dataPipelineConfigurationId={dataPipelineConfigurationId}
      filters={filters}
    />
  );
}

export default OpsCustomWidgetRoute;
